import Lottie from 'react-lottie-player'
import React from "react";
import lottieJson from '../../assets/AnimationFiles/FullmarksLoaderJsonfile.json'

type FullMarksLoaderProps = {
    width: number;
    height: number;
}

const FullMarksLoader = ({width,height}:FullMarksLoaderProps) => {
  return (
    <Lottie
    loop
    animationData={lottieJson}
    play
    style={{ width, height }}
    />
  );
};

export default FullMarksLoader;
